import { FC } from "react";

import { Header, SectionTitle, NovableLogo, Logo } from "./components";
import { ExportListButton } from "./components/ExportListButton";

export interface ListTopBarProps {
  title: string | undefined;
}

export const ListTopBar: FC<ListTopBarProps> = ({ title }) => {
  return (
    <Header>
      <SectionTitle>{title ? title : "List"}</SectionTitle>

      <ExportListButton />

      <NovableLogo>
        <Logo />
      </NovableLogo>
    </Header>
  );
};
